import React, { SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignFilter } from '../../../campaign/component/CampaignFilter';
import { IMyCampaignsFilterProps } from '../../../campaign/dto/IMyCampaigns';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import EmptyState from '../../../../../shared/components/placeholder/EmptyState';
import CardViewOffer from './CardViewOffer';
import { IOfferWithCampaign } from '../../../profile/profile-view';
import ListViewOfferCard from './ListViewOfferCard';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { Col, Row } from 'react-bootstrap';
import { OfferListSkeleton } from '../InfluencerDashboardSkeletons';

interface IOfferList {
    offers?: IOfferWithCampaign[];
    filterParams: IMyCampaignsFilterProps;
    setFilterParams: React.Dispatch<SetStateAction<IMyCampaignsFilterProps>>;
    isAgency?: boolean;
    isLoading?: boolean;
}

const OfferList = ({ offers, setFilterParams, filterParams, isAgency, isLoading = false }: IOfferList) => {
    const { t } = useTranslation();
    const [isCardView, setIsCardView] = useState(false);
    const { selectedInfluencer } = useSelector((state: IAllStates) => state.agency);

    return (
        <>
            {selectedInfluencer?.id ? (
                <h4>{t('influencer.dashboard.campaigns_from', { firstName: selectedInfluencer?.firstName })}</h4>
            ) : (
                <h4>{t('influencer.dashboard.yourCampaigns')}</h4>
            )}
            <div className={isCardView ? 'my-1' : 'mb-4'}>
                <CampaignFilter
                    searchKey="title"
                    isCardView={isCardView}
                    setIsCardView={setIsCardView}
                    filterParams={filterParams}
                    showCampaignStatus={false}
                    setFilterParams={setFilterParams}
                    isFilterLoading={isLoading}
                />
            </div>
            {isLoading ? (
                <OfferListSkeleton isCardView={isCardView} />
            ) : !!offers?.length ? (
                <div className="pt-3">
                    {isCardView ? (
                        <Row>
                            {offers.map(item => (
                                <Col key={item.id} className="my-2 col-12 col-lg-6 col-xl-4">
                                    <CardViewOffer offer={item} />
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <Row>
                            {offers.map(offer => (
                                <Col key={offer?.id} className="col-12 mb-4 pb-2">
                                    <ListViewOfferCard offer={offer} />
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>
            ) : (
                <CardLayout classCard="mt-3">
                    <EmptyState
                        navigateTo={isAgency ? '/agency/explore' : '/influencer/explore'}
                        btnText={t('general.tabs.explore')}
                    />
                </CardLayout>
            )}
        </>
    );
};

export default OfferList;
